"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var SubscriberRegistry = (function () {
    function SubscriberRegistry() {
        this._subscriptionsOfType = {};
    }
    SubscriberRegistry.prototype.getSubscriptionsOfType = function (eventType) {
        return this._subscriptionsOfType[eventType];
    };
    SubscriberRegistry.prototype.addSubscription = function (eventType, subscription) {
        if (!this._subscriptionsOfType[eventType]) {
            this._subscriptionsOfType[eventType] = [];
        }
        var index = this._subscriptionsOfType[eventType].length;
        this._subscriptionsOfType[eventType].push(subscription);
        subscription.eventType = eventType;
        subscription.index = index;
        return subscription;
    };
    SubscriberRegistry.prototype.removeAllSubscriptions = function (eventType) {
        if (eventType) {
            delete this._subscriptionsOfType[eventType];
        }
        else {
            this._subscriptionsOfType = {};
        }
    };
    SubscriberRegistry.prototype.removeSubscription = function (subscription) {
        var eventType = subscription.eventType;
        var index = subscription.index;
        var subscriptions = this._subscriptionsOfType[eventType];
        if (subscriptions) {
            delete subscriptions[index];
        }
    };
    return SubscriberRegistry;
}());
exports.default = SubscriberRegistry;
//# sourceMappingURL=suscriberRegistry.js.map